// -*- coding: utf-8 -*-
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function EmptyState({ message }) {
  return (
    <Box sx={{ py: 4, textAlign: 'center', color: 'text.secondary' }}>
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
}
